import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service to track unsaved changes across components
 * Components should update this service when they have unsaved changes
 */
@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  private hasUnsavedChanges$ = new BehaviorSubject<boolean>(false);

  /**
   * Get observable of unsaved changes state
   */
  getHasUnsavedChanges(): Observable<boolean> {
    return this.hasUnsavedChanges$.asObservable();
  }

  /**
   * Check if there are unsaved changes (synchronous)
   */
  hasUnsavedChanges(): boolean {
    return this.hasUnsavedChanges$.value;
  }

  /**
   * Set unsaved changes flag
   */
  setUnsavedChanges(hasChanges: boolean): void {
    this.hasUnsavedChanges$.next(hasChanges);
  }

  /**
   * Reset unsaved changes flag
   */
  reset(): void {
    this.hasUnsavedChanges$.next(false);
  }
}
